-<template>
    <section class="padding-vertical-content mb-3 mb-lg-4" id="paso-2">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="mb-4 h3 text-uppercase">
                        {{ $t('bases.completa_info') }}
                    </div>
                    <div class="padding-content white-content mb-2">
                        <div class="mb-4 h4 text-uppercase">
                            {{ $t('bases.datos_responsable_1') }}
                        </div>
                        <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                            <div class="row">
                                <div class="col-12 col-md-6 col-lg-4 mt-2">
                                    <div class="form-group">
                                        <label for="nombre">{{ $t("formularios.nombre") + ' *' }}</label>
                                        <ValidationProvider name="nombre_responsable" rules="required" v-slot="{ errors }">
                                            <input id="nombre_responsable" type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" :placeholder="$t('formularios.nombre')" v-model="localData.nombre_responsable" :disabled="!paso_activo" />
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4 mt-2">
                                    <div class="form-group">
                                        <label for="apellidos_responsable">{{ $t("formularios.apellidos") + ' *' }}</label>
                                        <ValidationProvider name="apellidos_responsable" rules="required" v-slot="{ errors }">
                                            <input id="apellidos_responsable" type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" :placeholder="$t('formularios.apellidos')" v-model="localData.apellidos_responsable" :disabled="!paso_activo" />
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4 mt-2">
                                    <div class="form-group">
                                        <label for="dni_responsable">DNI/NIE/PASAPORTE*</label>
                                        <ValidationProvider name="dni_responsable" rules="required" v-slot="{ errors }">
                                            <input id="dni_responsable" type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" :placeholder="$t('formularios.dni')" v-model="localData.dni_responsable" :disabled="!paso_activo" />
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4 mt-2">
                                    <div class="form-group">
                                        <label for="telefono_responsable">{{ $t("formularios.telefono") + ' *' }}</label>
                                        <ValidationProvider name="telefono_responsable" rules="required|numeric" v-slot="{ errors }">
                                            <input id="telefono_responsable" type="number" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" :placeholder="$t('formularios.telefono')" v-model="localData.telefono_responsable" :disabled="!paso_activo" />
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4 mt-2">
                                    <div class="form-group">
                                        <label for="email_responsable">{{ $t("formularios.email") + ' *' }}</label>
                                        <ValidationProvider name="email_responsable" rules="required" v-slot="{ errors }">
                                            <input id="email_responsable" type="email" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" :placeholder="$t('formularios.email')" v-model="localData.email_responsable" :disabled="!paso_activo" />
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <template v-if="fields && fields.length > 0">
                                    <div v-for="(field, index) in fields" :key="field.type + '_responsable_1_' + index" :class="'col-12' + (field.type !== 'textarea' ? ' col-lg-4' : '')">
                                        <FieldComponent 
                                            :field="field" 
                                            :desactivar="!paso_activo"
                                            entradaIndex="responsable_1"
                                            :fieldIndex="index"  
                                            v-model="localData.fields_responsable_1[field.name]"
                                        />
                                    </div>
                                </template>
                                <div class="col-12">
                                    <div class="mb-4 h4 text-uppercase">
                                        {{ $t('bases.datos_responsable_2') }}
                                    </div>    
                                </div>
                                <div class="col-12 col-md-6 col-lg-4 mt-2">
                                    <div class="form-group">
                                        <label for="nombre_responsable_2">{{ $t("formularios.nombre") }}</label>
                                        <ValidationProvider name="nombre_responsable_2" rules="" v-slot="{ errors }">
                                            <input id="nombre_responsable_2" type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" :placeholder="$t('formularios.nombre')" v-model="localData.nombre_responsable_2" :disabled="!paso_activo" />
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4 mt-2">
                                    <div class="form-group">
                                        <label for="apellidos_responsable_2">{{ $t("formularios.apellidos") }}</label>
                                        <ValidationProvider name="apellidos_responsable_2" rules="" v-slot="{ errors }">
                                            <input id="apellidos_responsable_2" type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" :placeholder="$t('formularios.apellidos')" v-model="localData.apellidos_responsable_2" :disabled="!paso_activo" />
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4 mt-2">
                                    <div class="form-group">
                                        <label for="dni_responsable_2">DNI/NIE/PASAPORTE</label>
                                        <ValidationProvider name="dni_responsable_2" rules="" v-slot="{ errors }">
                                            <input id="dni_responsable_2" type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" :placeholder="$t('formularios.dni')" v-model="localData.dni_responsable_2" :disabled="!paso_activo" />
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4 mt-2">
                                    <div class="form-group">
                                        <label for="telefono_responsable_2">{{ $t("formularios.telefono") }}</label>
                                        <ValidationProvider name="telefono_responsable_2" rules="numeric" v-slot="{ errors }">
                                            <input id="telefono_responsable_2" type="number" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" :placeholder="$t('formularios.telefono')" v-model="localData.telefono_responsable_2" :disabled="!paso_activo" />
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4 mt-2">
                                    <div class="form-group">
                                        <label for="email_responsable_2">{{ $t("formularios.email") }}</label>
                                        <ValidationProvider name="email_responsable_2" rules="email" v-slot="{ errors }">
                                            <input id="email_responsable_2" type="email" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" :placeholder="$t('formularios.email')" v-model="localData.email_responsable_2" :disabled="!paso_activo" />
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <template v-if="fields && fields.length > 0">
                                    <div v-for="(field, index) in fields" :key="field.type + '_responsable_2_' + index" :class="'col-12' + (field.type !== 'textarea' ? ' col-lg-4' : '')">
                                        <FieldComponent 
                                            :field="field" 
                                            :desactivar="!paso_activo"
                                            entradaIndex="responsable_2"
                                            :fieldIndex="index"
                                            v-model="localData.fields_responsable_2[field.name]"
                                        />
                                    </div>
                                </template>
                                <br />
                                <div class="col-12 col-md-12 col-lg-12 mt-2">
                                    <div class="form-group">
                                        <label for="observaciones">{{ $t('formularios.observaciones') }}</label>
                                        <ValidationProvider name="observaciones">
                                            <input id="observaciones" type="textarea" class='form-control' placeholder="Observaciones" v-model="localData.observaciones" :disabled="!paso_activo" />
                                        </ValidationProvider>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <button type="submit" name="button" :class="!esMovil ? 'button effect-button large-button' : 'button effect-button'" id="terminar-paso-2" :disabled="!paso_activo">
                                    <span>{{ $t('formularios.continuar') }}</span>
                                </button>
                                <button @click="volver" name="button" :class="!esMovil ? 'button effect-button large-button ml-2' : 'button effect-button ml-2'" id="volver-paso-1" :disabled="!paso_activo" >
                                    <span>{{ $t('formularios.atras') }}</span>
                                </button>
                            </div>
                        </ValidationObserver>
                    </div>
                </div>
            </div>
        </div>
    </section>  
</template>

<script>
    import FieldComponent from '@/components/common/FieldComponent.vue';

    export default {
        props: {
            base: {
                type: Object,
                required: true
            },
            paso_activo: {
                type: Boolean,
                default: false
            },
            esMovil: {
                type: Boolean,
                default: false
            },
            fields: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                localData: { ...this.base }
            };
        },
        methods: {
            terminar() {
                let params = {
                    base: this.localData,
                    filters: {
                        tid: this.configuracion.hash_teatro,
                    }
                }
                this.$store.dispatch(this.config.getVuexAlias('front.bases.guardar-datos-deportista'), params).then(res => {
                    this.localData.session_id = res.data.session_id;
                    this.localData.jet_id = res.data.jet_id;
                });
                this.$emit('terminado', this.localData);
            },
            volver() {
                this.$emit('volver')
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.terminar();
                }
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            }
        },
        components: {
            FieldComponent
        }
    };
</script>